import { Link } from "react-router-dom";
import ButtonPlay from "../components/ButtonPlay";
import { CookiesModal } from "../components/CookiesModal";
import { CookiesModalPreferences } from "../components/CookiesModalPreferences";
import ReactPlayer from "react-player/youtube";
import { useGameContext } from "../context/useGameContext";
import ReactPixel from "react-facebook-pixel";

export const LobbyPage = () => {
  const { gameSetup } = useGameContext();
  return (
    <>
      <div className=" lobbyPage">
        <p className="title font-anton has-text-weight-light pt-5">
          Instrukcja jak wziąć udział
        </p>
        <p className=" is-uppercase font-antonio is-4">Prościej się nie dało</p>
        <section className="section">
          <div className="numeration-text mb-4">
            <strong className="has-text-weight-bold number">1</strong>
            <p className="title is-5 has-text-left has-text-weight-light">
              Dołącz do wyzwania! Zobaczysz miejsce, gdzieś na świecie.
              Rozejrzyj się dookoła (zrobisz to przytrzymując i przesujawąc
              widok).
            </p>
          </div>
          <div className="numeration-text mb-4">
            <strong className="has-text-weight-bold number">2</strong>
            <p className="title is-5 has-text-left has-text-weight-light">
              Nastepnie kliknij na mapę świata, aby ją otworzyć. Przybliż widok,
              aby precyzyjnie zaznaczyć miejsce. Jeśli nie masz pewności, możesz
              zaznaczyć parę miejsc.
            </p>
          </div>
          <div className="numeration-text mb-4">
            <strong className="has-text-weight-bold number">3</strong>
            <p className="title is-5 has-text-left has-text-weight-light">
              Będziesz najbliżej od innych graczy,{" "}
              <strong className="has-text-weight-bold">
                WYGRYWASZ 500 PLN
              </strong>
            </p>
          </div>
          <div className="numeration-text">
            <p className="title is-5 has-text-left has-text-weight-light instruction-text mt-5">
              <strong className="has-text-weight-bold">Uwaga:</strong> udział
              w konkursie wymaga posiadania Certyfikatu Wsparcia Schroniska —
              każde zaznaczenie na mapie automatycznie kupuje/wykorzystuje
              certyfikat o wartości
              <strong className="has-text-weight-bold">
                {" "}
                {gameSetup.price.toFixed(2)} PLN{" "}
              </strong>
              za każde zaznaczenie. Większość środków z certyfikatów
              przeznaczona zostanie na schroniska dla bezdomnych zwierząt
              ⋆˚🐾˖°. Bądź na bieżąco śledząc nasze sociale!
            </p>
          </div>
        </section>
        <div className="mb-5">
          <nav className="level">
            <div className="level-item has-text-centered">
              <Link to="/game">
                <ButtonPlay title="Zaczynamy!" />
              </Link>
            </div>
          </nav>
        </div>

        {/* <section className="section">
          <ReactPlayer
            controls={true}
            playing={false}
            url=""
            width="auto"
          />
        </section> */}
        <CookiesModal />
        <CookiesModalPreferences />
      </div>
    </>
  );
};
